import React from 'react';
import PropTypes from 'prop-types';

import { useCityName } from '@spotahome/marketplace-common/src/context/CitiesContext';

import Crumb from './Crumb';

const CityCrumb = ({ href, cityId }) => (
  <Crumb label={useCityName(cityId)} href={href} position={2} />
);

CityCrumb.propTypes = {
  href: PropTypes.string.isRequired,
  cityId: PropTypes.string.isRequired
};

export default CityCrumb;
